"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFieldSchema = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _dateFns = require("date-fns");
var _zod = require("zod");
var _models = require("../models");
var _generateDateFormat = require("./generateDateFormat");
const createFieldSchema = (formatMessage, fieldConfig, type, culturePattern, exceptionField) => {
  const correctCulturePattern = culturePattern ?? '';
  const dateFormat = (0, _generateDateFormat.generateDateFormat)(correctCulturePattern);
  let correctRegexMessageKey = _models.TranslationKey.validationRegex;
  switch (exceptionField) {
    case 'uniqueId':
      correctRegexMessageKey = _models.TranslationKey.validationRegexUniqueID;
      break;
    case 'email':
      correctRegexMessageKey = _models.TranslationKey.validationRegexEmail;
      break;
    case 'phone':
      correctRegexMessageKey = _models.TranslationKey.validationRegexPhone;
      break;
    default:
      correctRegexMessageKey = _models.TranslationKey.validationRegex;
  }
  if (!fieldConfig?.validation?.isMandatory) {
    switch (type) {
      case 'string':
        return _zod.z.string().nullish().refine(val => !val || new RegExp(fieldConfig?.validation?.regularExpression ?? '').test(val), formatMessage(correctRegexMessageKey));
      case 'number':
        return _zod.z.number().nullish();
      case 'date':
        return _zod.z.date({
          errorMap: (issue, {
            defaultError
          }) => ({
            message: issue.code === 'invalid_date' ? formatMessage(_models.TranslationKey.validationBirthDateRegex, {
              correctFormat: dateFormat.toUpperCase()
            }) : defaultError
          })
        }).nullish();
      case 'boolean':
        return _zod.z.boolean().nullish();
      case 'genderEnum':
        return _zod.z.nativeEnum(_globalApiClientReact.OptionalNullableCustomerGenderValue).nullish();
      default:
        throw new Error(`Unsupported type: ${type}`);
    }
  }
  let fieldSchema;
  const minDate = fieldConfig.validation.minValue ? new Date(fieldConfig.validation.minValue) : undefined;
  const maxDate = fieldConfig.validation.maxValue ? new Date(fieldConfig.validation.maxValue) : undefined;
  const formattedMax = maxDate ? (0, _dateFns.format)(maxDate, correctCulturePattern).replaceAll(' ', '') : null;
  const formattedMin = minDate ? (0, _dateFns.format)(minDate, correctCulturePattern).replaceAll(' ', '') : null;
  switch (type) {
    case 'string':
      fieldSchema = _zod.z.string({
        message: formatMessage(_models.TranslationKey.validationRequired)
      }).min(1, {
        message: formatMessage(_models.TranslationKey.validationRequired)
      }).regex(new RegExp(fieldConfig.validation.regularExpression ?? ''), formatMessage(correctRegexMessageKey)).min(fieldConfig.validation.minLength ?? 1, formatMessage(_models.TranslationKey.validationMinLength, {
        min: fieldConfig.validation.minLength
      })).max(fieldConfig.validation.maxLength ?? 255, formatMessage(_models.TranslationKey.validationMaxLength, {
        max: fieldConfig.validation.maxLength
      }));
      break;
    case 'number':
      fieldSchema = _zod.z.number({
        message: formatMessage(_models.TranslationKey.validationRequired)
      });
      break;
    case 'date':
      fieldSchema = _zod.z.date({
        message: formatMessage(_models.TranslationKey.validationRequired),
        errorMap: (issue, {
          defaultError
        }) => ({
          message: issue.code === 'invalid_date' ? formatMessage(_models.TranslationKey.validationBirthDateRegex, {
            correctFormat: dateFormat.toUpperCase()
          }) : defaultError
        })
      }).nullable().refine(val => val !== null, {
        message: formatMessage(_models.TranslationKey.validationRequired)
      });
      if (fieldConfig.validation.minValue) {
        fieldSchema = fieldSchema.refine(val => val !== null && val.getTime() >= (fieldConfig?.validation?.minValue?.getTime() ?? new Date().getTime()), {
          message: formatMessage(_models.TranslationKey.validationMinValue, {
            min: formattedMin
          })
        });
      }
      if (fieldConfig.validation.maxValue) {
        fieldSchema = fieldSchema.refine(val => val !== null && val.getTime() <= (fieldConfig?.validation?.maxValue?.getTime() ?? new Date().getTime()), {
          message: formatMessage(_models.TranslationKey.validationMaxValue, {
            max: formattedMax
          })
        });
      }
      break;
    case 'boolean':
      fieldSchema = _zod.z.boolean().refine(val => val, {
        message: formatMessage(_models.TranslationKey.validationRequired)
      });
      break;
    case 'genderEnum':
      fieldSchema = _zod.z.union([_zod.z.nativeEnum(_globalApiClientReact.OptionalNullableCustomerGenderValue), _zod.z.null(), _zod.z.undefined()]).refine(val => val !== undefined && val !== null, {
        message: formatMessage(_models.TranslationKey.validationRequired)
      });
      break;
    default:
      throw new Error(`Unsupported type: ${type}`);
  }
  return fieldSchema;
};
exports.createFieldSchema = createFieldSchema;